import { wsV2 } from '@newtontechnologies/beey-api-js-client/endpoints';
export const subSystemList = [
    'ChainControl', 'Upload', 'Transcoding', 'TranscodingAudio', 'TranscodingVideo', 'MediaIdentification',
    'MediaFileIndexing', 'MediaFilePackaging', 'TranscriptionTracking', 'TranscriptionQueueTracking',
    'CreditReservation', 'TranscriptionStreaming', 'ProjectUpdates', 'ExclusiveAccess',
];
const openSocket = (baseURL, urlParams) => new WebSocket(`${baseURL}?subsystemFilter=${subSystemList.join(';')}${urlParams}`);
export const openUploadSocket = (projectId) => openSocket(`${wsV2.url()}/Upload`, `&id=${projectId}&saveMedia=true&transcodingProfile=lowlatency`);
export const openLiveUpdateSocket = (urlParams) => openSocket(`${wsV2.url()}/LiveUpdate`, urlParams);
